module.exports = __webpack_public_path__ + "img/slice_inernal_example.6aa32199.png";